<template>
  <v-app class="privacy-page">
    <v-main>
      <v-container class="policy-container py-10 py-md-14">
        <header class="policy-header mb-10">
          <div class="brand">TIJARAT</div>
          <h1>Privacy Policy</h1>
          <p class="effective-date">Effective September 7, 2026</p>
        </header>

        <section>
          <p>
            This Privacy Policy explains how Matt Consulting Services Inc.,
            doing business as SMPL Sale ("SMPL Sale," "we," "us," or "our"),
            handles information when you use the TIJARAT mobile application and
            related ordering services (collectively, the "Services").
          </p>
        </section>

        <section>
          <h2>Information we collect</h2>
          <p>We collect information needed to provide wholesale ordering services, including:</p>
          <ul>
            <li>Your phone number and phone-verification status.</li>
            <li>Your name, business account, assigned locations, and delivery or billing details.</li>
            <li>Orders, saved carts, invoices, balances, product selections, and related transaction records.</li>
            <li>Technical information such as app version, device and browser type, IP address, diagnostics, and security logs.</li>
            <li>Information you voluntarily provide when contacting support.</li>
          </ul>
        </section>

        <section>
          <h2>How we use information</h2>
          <ul>
            <li>Authenticate users and protect customer accounts.</li>
            <li>Display authorized products, pricing, locations, invoices, and account information.</li>
            <li>Create, process, fulfill, and maintain wholesale orders.</li>
            <li>Provide support, service messages, and important app or account updates.</li>
            <li>Maintain security, prevent fraud, diagnose problems, and improve the Services.</li>
            <li>Comply with applicable legal, tax, and recordkeeping obligations.</li>
          </ul>
        </section>

        <section>
          <h2>How we share information</h2>
          <p>
            We do not sell personal information and do not use it for third-party
            advertising. We may share information with the TIJARAT wholesale
            organization and locations associated with your account, and with
            service providers that support hosting, communications, phone
            verification, security, analytics, and order operations. We may also
            disclose information when required by law or to protect users, our
            Services, or others.
          </p>
        </section>

        <section>
          <h2>Data retention and security</h2>
          <p>
            We retain information for as long as needed to provide the Services,
            maintain business and transaction records, resolve disputes, enforce
            agreements, and meet legal obligations. We use reasonable
            administrative, technical, and organizational safeguards, including
            encrypted network connections, but no system can guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>Your choices and requests</h2>
          <p>
            You may request access to, correction of, or deletion of your personal
            information, subject to legal and business-record requirements. You
            may also request account deletion by contacting us. We may need to
            verify your identity before completing a request.
          </p>
        </section>

        <section>
          <h2>Children</h2>
          <p>
            The Services are intended for business users and are not directed to
            children under 13. We do not knowingly collect personal information
            from children under 13.
          </p>
        </section>

        <section>
          <h2>Changes to this policy</h2>
          <p>
            We may update this policy as our Services or legal obligations change.
            We will post the updated policy here and revise the effective date.
          </p>
        </section>

        <section>
          <h2>Contact us</h2>
          <p>
            Matt Consulting Services Inc., d/b/a SMPL Sale<br>
            263 Village Avenue, Lynbrook, NY 11563<br>
            Email: <a href="mailto:info@smplsale.com">info@smplsale.com</a><br>
            Phone: <a href="tel:+19175297186">917-529-7186</a>
          </p>
        </section>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  mounted() {
    document.title = "TIJARAT Privacy Policy";
  },
};
</script>

<style scoped>
.privacy-page { background: #f5f8f7; color: #17233a; }
.policy-container { max-width: 860px; }
.policy-header { border-bottom: 1px solid #d9e3df; padding-bottom: 24px; }
.brand { color: #176b58; font-size: 14px; font-weight: 900; letter-spacing: .18em; }
h1 { font-size: clamp(34px, 7vw, 52px); line-height: 1.1; margin: 10px 0; }
.effective-date { color: #63736d; margin: 0; }
section { background: white; border: 1px solid #e0e8e5; border-radius: 16px; margin: 18px 0; padding: 24px; }
h2 { color: #176b58; font-size: 21px; margin: 0 0 12px; }
p, li { font-size: 16px; line-height: 1.7; }
ul { padding-left: 22px; }
a { color: #176b58; font-weight: 700; }
@media (max-width: 600px) { .policy-container { padding: 24px 16px !important; } section { padding: 19px; } }
</style>
